import { render, staticRenderFns } from "./GarageBid.vue?vue&type=template&id=847061a8&scoped=true"
import script from "./GarageBid.vue?vue&type=script&lang=js"
export * from "./GarageBid.vue?vue&type=script&lang=js"
import style0 from "./GarageBid.vue?vue&type=style&index=0&id=847061a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847061a8",
  null
  
)

export default component.exports